(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zap-announcement"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zap-announce')) {
    customElements.define('zap-announce', class extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('.za__item'));
        if (this.items.length < 2) return;
        this.index = 0;
        this.paused = false;
        const pause = () => { this.paused = true; };
        const resume = () => { this.paused = false; };
        this.addEventListener('mouseenter', pause);
        this.addEventListener('mouseleave', resume);
        this.addEventListener('focusin', pause);
        this.addEventListener('focusout', resume);
        this.addEventListener('touchstart', pause, { passive: true });
        const seconds = Math.max(3, parseInt(this.dataset.interval, 10) || 5);
        this.timer = setInterval(() => this.next(), seconds * 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      next() {
        if (this.paused || window.matchMedia('(min-width: 990px)').matches) return;
        this.items[this.index].classList.remove('is-active');
        this.index = (this.index + 1) % this.items.length;
        this.items[this.index].classList.add('is-active');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zap-article"]) return;
  try {
    
  if (!customElements.get('zap-article')) {
    customElements.define('zap-article', class extends HTMLElement {
      connectedCallback() {
        this.buildToc();
        this.addEventListener('click', (e) => {
          const btn = e.target.closest('[data-zar-copy]');
          if (!btn || !navigator.clipboard) return;
          navigator.clipboard.writeText(btn.dataset.zarCopy).then(() => {
            const label = btn.querySelector('span');
            const live = this.querySelector('[data-zar-live]');
            const old = label ? label.textContent : '';
            if (label) label.textContent = this.dataset.copied || 'Link copied';
            if (live) live.textContent = this.dataset.copied || 'Link copied';
            setTimeout(() => { if (label) label.textContent = old; if (live) live.textContent = ''; }, 1600);
          }).catch(() => {});
        });
      }
      slug(text) {
        return text.toLowerCase().normalize('NFKD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'section';
      }
      buildToc() {
        const content = this.querySelector('[data-zar-content]');
        const boxes = Array.from(this.querySelectorAll('[data-zar-toc-box]'));
        if (!content || !boxes.length) return;
        const heads = Array.from(content.querySelectorAll('h2')).filter((h) => h.textContent.trim());
        if (heads.length < 2) return;
        const used = new Set();
        heads.forEach((h) => {
          let id = h.id || this.slug(h.textContent);
          let n = 2;
          while (used.has(id) || (document.getElementById(id) && document.getElementById(id) !== h)) { id = `${id.replace(/-\d+$/, '')}-${n}`; n += 1; }
          h.id = id;
          used.add(id);
        });
        boxes.forEach((box) => {
          const list = box.querySelector('[data-zar-toc-list]');
          list.innerHTML = '';
          heads.forEach((h) => {
            const li = document.createElement('li');
            const a = document.createElement('a');
            a.href = `#${h.id}`;
            a.textContent = h.textContent.trim();
            li.appendChild(a);
            list.appendChild(li);
          });
          box.hidden = false;
        });
        this.querySelectorAll('.zar__toc-mobile a').forEach((a) => a.addEventListener('click', () => { const d = a.closest('details'); if (d) d.open = false; }));
        if (!('IntersectionObserver' in window)) return;
        const links = Array.from(this.querySelectorAll('.zar__toc [data-zar-toc-list] a'));
        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            links.forEach((a) => { if (a.getAttribute('href') === `#${entry.target.id}`) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
          });
        }, { rootMargin: '-15% 0px -75% 0px' });
        heads.forEach((h) => io.observe(h));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zap-bundle-builder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zap-bundle')) {
    customElements.define('zap-bundle', class extends HTMLElement {
      connectedCallback() {
        this.max = parseInt(this.dataset.max, 10) || 4;
        this.min = Math.min(parseInt(this.dataset.min, 10) || 1, this.max);
        this.word = this.dataset.word || 'items';
        this.tiers = (this.dataset.tiers || '').split(',')
          .map((t) => t.split(':').map((n) => parseFloat(n)))
          .filter(([qty, pct]) => qty > 0 && pct > 0)
          .map(([qty, pct]) => ({ qty, pct }))
          .sort((a, b) => a.qty - b.qty);
        this.picked = [];
        this.picks = Array.from(this.querySelectorAll('.zbb__pick'));
        this.slots = Array.from(this.querySelectorAll('.zbb__slot'));
        this.tierEls = Array.from(this.querySelectorAll('.zbb__tier'));
        this.addButton = this.querySelector('[data-add]');
        this.picks.forEach((btn) => btn.addEventListener('click', () => this.pick(btn)));
        this.addButton.addEventListener('click', () => this.add());
        this.render();
      }
      money(cents) {
        const value = (cents / 100).toFixed(2);
        const format = (this.dataset.moneyFormat || '').replace(/<[^>]*>/g, '').trim();
        if (!format) return `£${value}`;
        return format
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
          .replace(/\{\{\s*amount\s*\}\}/, value);
      }
      tierFor(count) {
        let current = null;
        this.tiers.forEach((t) => { if (count >= t.qty) current = t; });
        return current;
      }
      nextTier(count) {
        return this.tiers.find((t) => t.qty > count && t.qty <= this.max) || null;
      }
      pick(btn) {
        if (this.picked.length >= this.max) return;
        this.picked.push({ id: btn.dataset.id, price: parseInt(btn.dataset.price, 10) || 0, name: btn.dataset.name, img: btn.dataset.img });
        this.render();
      }
      remove(index) {
        this.picked.splice(index, 1);
        this.render();
        const nextRemove = this.querySelector('.zbb__remove');
        const firstPick = this.picks.find((p) => p.getAttribute('aria-disabled') !== 'true');
        if (nextRemove) nextRemove.focus(); else if (firstPick) firstPick.focus();
      }
      render() {
        const count = this.picked.length;
        const full = count >= this.max;
        this.slots.forEach((slot, i) => {
          const item = this.picked[i];
          slot.classList.toggle('is-filled', Boolean(item));
          slot.innerHTML = '';
          if (item) {
            if (item.img) { const img = document.createElement('img'); img.src = item.img; img.alt = ''; slot.appendChild(img); }
            const name = document.createElement('span'); name.className = 'zbb__slot-name'; name.textContent = item.name; slot.appendChild(name);
            const rm = document.createElement('button'); rm.type = 'button'; rm.className = 'zbb__remove';
            rm.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
            rm.setAttribute('aria-label', `Remove ${item.name}`);
            rm.addEventListener('click', () => this.remove(i));
            slot.appendChild(rm);
          } else {
            const num = document.createElement('span'); num.className = 'zbb__slot-num'; num.textContent = String(i + 1); slot.appendChild(num);
          }
        });
        this.picks.forEach((btn) => {
          const n = this.picked.filter((p) => p.id === btn.dataset.id).length;
          const badge = btn.querySelector('[data-qty]');
          badge.hidden = n === 0;
          badge.textContent = n ? `×${n}` : '';
          btn.classList.toggle('is-selected', n > 0);
          btn.setAttribute('aria-disabled', full ? 'true' : 'false');
        });

        const tier = this.tierFor(count);
        const next = this.nextTier(count);
        const pct = tier ? tier.pct : 0;
        this.tierEls.forEach((el) => {
          const qty = parseFloat(el.dataset.tier);
          el.classList.toggle('is-reached', count >= qty);
          el.classList.toggle('is-active', Boolean(tier) && qty === tier.qty);
        });

        const full_total = this.picked.reduce((sum, p) => sum + p.price, 0);
        const total = Math.round(full_total * (100 - pct) / 100);
        const was = this.querySelector('[data-was]');
        const saving = this.querySelector('[data-saving]');
        this.querySelector('[data-total]').textContent = this.money(total);
        was.hidden = !(pct > 0 && count > 0);
        was.textContent = this.money(full_total);
        saving.hidden = !(pct > 0 && count > 0);
        saving.textContent = `You save ${this.money(full_total - total)} (${pct}% off)`;

        let message = '';
        if (count === 0) {
          message = this.tiers.length ? `Pick ${this.tiers[0].qty} ${this.word} to save ${this.tiers[0].pct}%` : `Pick up to ${this.max} ${this.word}`;
        } else if (next) {
          const more = next.qty - count;
          message = `Add ${more} more to save ${next.pct}%`;
        } else if (pct > 0) {
          message = `Top saving unlocked: ${pct}% off`;
        } else if (count < this.min) {
          message = `Pick ${this.min - count} more`;
        }
        this.querySelector('[data-message]').textContent = message;
        this.querySelector('[data-count]').textContent = String(count);

        const label = this.dataset.button || 'Add to cart';
        this.addButton.textContent = label.replace('[count]', String(Math.max(count, this.min)));
        this.addButton.disabled = count < this.min;
      }
      async add() {
        if (this.picked.length < this.min) return;
        const error = this.querySelector('[data-error]');
        const counts = {};
        this.picked.forEach((p) => { counts[p.id] = (counts[p.id] || 0) + 1; });
        this.addButton.disabled = true;
        this.addButton.setAttribute('aria-busy', 'true');
        try {
          const res = await fetch(`${this.dataset.addUrl}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: Object.keys(counts).map((id) => ({ id: Number(id), quantity: counts[id] })) })
          });
          if (!res.ok) throw new Error('add failed');
          window.location.href = this.dataset.cartUrl;
        } catch (e) {
          this.addButton.disabled = false;
          this.addButton.removeAttribute('aria-busy');
          if (error) error.hidden = false;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zap-collection-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zap-sort')) {
    customElements.define('zap-sort', class extends HTMLElement {
      connectedCallback() {
        const select = this.querySelector('select');
        if (select) select.addEventListener('change', () => select.form.submit());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zap-contact"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zap-contact')) {
    customElements.define('zap-contact', class extends HTMLElement {
      connectedCallback() {
        const notice = this.querySelector('[data-zct-success], [data-zct-errors]');
        if (notice) { notice.scrollIntoView({ block: 'center' }); notice.focus({ preventScroll: true }); }
        this.addEventListener('click', (e) => {
          const btn = e.target.closest('[data-zct-copy]');
          if (!btn || !navigator.clipboard) return;
          navigator.clipboard.writeText(btn.dataset.zctCopy).then(() => {
            const label = btn.textContent;
            const live = this.querySelector('[data-zct-live]');
            btn.textContent = btn.dataset.copied || 'Copied';
            if (live) live.textContent = btn.textContent;
            setTimeout(() => { btn.textContent = label; if (live) live.textContent = ''; }, 1600);
          }).catch(() => {});
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zap-faq-hub"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zap-faq-hub')) {
    customElements.define('zap-faq-hub', class extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-zfh-search]');
        this.clear = this.querySelector('[data-zfh-clear]');
        this.status = this.querySelector('[data-zfh-status]');
        this.empty = this.querySelector('[data-zfh-empty]');
        this.items = Array.from(this.querySelectorAll('[data-zfh-item]'));
        this.groups = Array.from(this.querySelectorAll('[data-zfh-group]'));
        this.chips = Array.from(this.querySelectorAll('[data-zfh-term]'));
        this.pairs = (this.dataset.synonyms || '').split(/\n/).map((l) => l.split('=').map((x) => x.trim().toLowerCase())).filter((p) => p.length === 2 && p[0] && p[1]);
        this.items.forEach((item) => {
          const q = item.querySelector('[data-zfh-q]');
          item.zfhQ = q ? q.textContent.trim() : '';
          let text = item.textContent.toLowerCase().replace(/\s+/g, ' ');
          this.pairs.forEach(([a, b]) => { if (text.includes(b) && !text.includes(a)) text += ` ${a}`; else if (text.includes(a) && !text.includes(b)) text += ` ${b}`; });
          item.zfhText = text;
        });
        if (this.input) {
          let t;
          this.input.addEventListener('input', () => { clearTimeout(t); t = setTimeout(() => this.apply(), 120); });
          this.input.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.input.value) { this.input.value = ''; this.apply(); } });
        }
        if (this.clear) this.clear.addEventListener('click', () => { this.input.value = ''; this.apply(); this.input.focus(); });
        this.chips.forEach((chip) => chip.addEventListener('click', () => {
          const on = chip.getAttribute('aria-pressed') === 'true';
          this.input.value = on ? '' : chip.dataset.zfhTerm;
          this.apply();
        }));
        this.openFromHash();
        window.addEventListener('hashchange', () => this.openFromHash());
        this.watchNav();
      }
      openFromHash() {
        const hash = window.location.hash ? decodeURIComponent(window.location.hash.slice(1)) : '';
        if (!hash) return;
        const target = this.querySelector(`details[id="${CSS.escape(hash)}"]`);
        if (!target) return;
        target.open = true;
        requestAnimationFrame(() => target.scrollIntoView({ block: 'start' }));
      }
      esc(s) { return s.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }
      words(q) { return q.toLowerCase().split(/\s+/).filter((w) => w.length > 1); }
      apply() {
        const raw = this.input ? this.input.value.trim() : '';
        const words = raw.length > 1 ? this.words(raw) : [];
        let shown = 0;
        const matched = [];
        this.items.forEach((item) => {
          const ok = !words.length || words.every((w) => item.zfhText.includes(w));
          item.hidden = !ok;
          if (ok) { shown += 1; if (words.length) matched.push(item); }
          const q = item.querySelector('[data-zfh-q]');
          if (!q) return;
          if (words.length && ok) {
            let html = this.esc(item.zfhQ);
            words.forEach((w) => {
              const re = new RegExp(`(${w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'ig');
              html = html.replace(re, '<mark>$1</mark>');
            });
            q.innerHTML = html;
          } else if (q.querySelector('mark')) {
            q.textContent = item.zfhQ;
          }
        });
        if (words.length && matched.length && matched.length <= 3) matched.forEach((item) => { item.open = true; });
        this.groups.forEach((group) => {
          const visible = group.querySelectorAll('[data-zfh-item]:not([hidden])').length;
          group.hidden = visible === 0;
          const id = group.dataset.zfhGroup;
          const nav = id ? this.querySelector(`[data-zfh-navitem="${CSS.escape(id)}"]`) : null;
          if (nav) {
            nav.hidden = visible === 0;
            const count = nav.querySelector('[data-zfh-count]');
            if (count) count.textContent = visible;
          }
        });
        if (this.empty) this.empty.hidden = shown > 0;
        if (this.clear) this.clear.hidden = !raw;
        this.chips.forEach((chip) => chip.setAttribute('aria-pressed', String(chip.dataset.zfhTerm.toLowerCase() === raw.toLowerCase())));
        if (this.status) {
          let msg = this.dataset.statusAll || '[count]';
          if (words.length) msg = shown === 0 ? this.dataset.statusNone : shown === 1 ? this.dataset.statusOne : this.dataset.statusFound;
          this.status.textContent = (msg || '').replace('[count]', shown).replace('[term]', raw);
        }
      }
      watchNav() {
        const links = Array.from(this.querySelectorAll('.zfh__nav-link'));
        if (!links.length || !('IntersectionObserver' in window)) return;
        const byId = new Map(links.map((a) => [decodeURIComponent(a.getAttribute('href').slice(1)), a]));
        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const link = byId.get(entry.target.id);
            if (!link) return;
            links.forEach((a) => a.removeAttribute('aria-current'));
            link.setAttribute('aria-current', 'true');
          });
        }, { rootMargin: '-20% 0px -70% 0px' });
        this.groups.forEach((g) => { if (g.id) io.observe(g); });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zap-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zap-footer-cols')) {
    customElements.define('zap-footer-cols', class extends HTMLElement {
      connectedCallback() {
        this.mq = window.matchMedia('(max-width: 749px)');
        this.cols = Array.from(this.querySelectorAll('.zf__col'));
        this.apply = () => this.cols.forEach((col) => { col.open = !this.mq.matches; });
        this.apply();
        this.mq.addEventListener('change', this.apply);
        this.cols.forEach((col) => col.querySelector('summary').addEventListener('click', (e) => {
          if (!this.mq.matches) e.preventDefault();
        }));
      }
      disconnectedCallback() { this.mq.removeEventListener('change', this.apply); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zap-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zap-guide')) {
    customElements.define('zap-guide', class extends HTMLElement {
      connectedCallback() {
        const limit = parseInt(this.dataset.collapse, 10) || 0;
        this.body = this.querySelector('[data-zgd-body]');
        this.more = this.querySelector('[data-zgd-more]');
        if (!limit || !this.body || !this.more || this.body.scrollHeight <= limit + 160) return;
        this.body.style.setProperty('--zgd-height', `${limit}px`);
        this.body.classList.add('is-collapsed');
        this.more.hidden = false;
        this.more.addEventListener('click', () => this.toggle());
        this.querySelectorAll('[data-zgd-link]').forEach((a) => a.addEventListener('click', () => this.toggle(true)));
        const target = window.location.hash ? document.getElementById(decodeURIComponent(window.location.hash.slice(1))) : null;
        if (target && this.body.contains(target)) this.toggle(true);
      }
      toggle(forceOpen) {
        const open = forceOpen === true ? true : this.body.classList.contains('is-collapsed');
        this.body.classList.toggle('is-collapsed', !open);
        this.more.setAttribute('aria-expanded', String(open));
        this.more.querySelector('[data-more]').hidden = open;
        this.more.querySelector('[data-less]').hidden = !open;
        if (!open) this.scrollIntoView({ block: 'start' });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zap-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zap-header')) {
    customElements.define('zap-header', class extends HTMLElement {
      connectedCallback() {
        this.wrapper = this.closest('.shopify-section') || this;
        this.desktop = window.matchMedia('(min-width: 990px)');
        this.items = Array.from(this.querySelectorAll('[data-zh-item]'));
        this.items.forEach((item) => this.bindItem(item));

        this.drawer = this.querySelector('.zh__drawer');
        this.burger = this.querySelector('[data-zh-drawer-open]');
        if (this.burger) this.burger.addEventListener('click', () => this.openDrawer());
        this.querySelectorAll('[data-zh-drawer-close], [data-zh-drawer-close-link]').forEach((el) => el.addEventListener('click', () => this.closeDrawer()));

        this.search = this.querySelector('.zh__search');
        this.searchBtn = this.querySelector('[data-zh-search-open]');
        this.input = this.querySelector('[data-zh-search-input]');
        this.results = this.querySelector('[data-zh-results]');
        this.quick = this.querySelector('[data-zh-quick]');
        if (this.searchBtn) this.searchBtn.addEventListener('click', () => (this.search.hidden ? this.openSearch() : this.closeSearch()));
        const closeSearch = this.querySelector('[data-zh-search-close]');
        if (closeSearch) closeSearch.addEventListener('click', () => this.closeSearch(true));
        if (this.input && this.dataset.suggest) {
          let t;
          this.input.addEventListener('input', () => {
            clearTimeout(t);
            t = setTimeout(() => this.suggest(this.input.value), 250);
          });
        }

        this.onKey = (e) => {
          if (e.key !== 'Escape') return;
          const open = this.querySelector('.zh__item.is-open');
          if (open) { this.closeMega(open); open.querySelector('.zh__toggle').focus(); }
          if (this.drawer && !this.drawer.hidden) this.closeDrawer();
          if (this.search && !this.search.hidden) this.closeSearch(true);
        };
        this.onDocClick = (e) => {
          if (this.search && !this.search.hidden && !this.contains(e.target)) this.closeSearch();
        };
        document.addEventListener('keydown', this.onKey);
        document.addEventListener('click', this.onDocClick);

        this.lastY = window.scrollY;
        this.onScroll = () => this.handleScroll();
        if (this.dataset.sticky === 'scroll_up') window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onResize = () => this.setHeight();
        window.addEventListener('resize', this.onResize);
        this.setHeight();
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.onKey);
        document.removeEventListener('click', this.onDocClick);
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        document.documentElement.classList.remove('zh-lock');
      }

      setHeight() {
        const h = this.querySelector('.zh__bar').offsetHeight;
        document.documentElement.style.setProperty('--zh-height', h + 'px');
        document.documentElement.style.setProperty('--header-height', h + 'px');
      }

      bindItem(item) {
        const btn = item.querySelector('.zh__toggle');
        let timer;
        item.addEventListener('mouseenter', () => {
          if (!this.desktop.matches) return;
          clearTimeout(timer);
          timer = setTimeout(() => this.openMega(item), 90);
        });
        item.addEventListener('mouseleave', () => {
          clearTimeout(timer);
          timer = setTimeout(() => this.closeMega(item), 160);
        });
        btn.addEventListener('click', () => (item.classList.contains('is-open') ? this.closeMega(item) : this.openMega(item)));
        item.addEventListener('focusout', (e) => {
          if (!item.contains(e.relatedTarget)) this.closeMega(item);
        });
      }

      openMega(item) {
        this.items.forEach((other) => { if (other !== item) this.closeMega(other); });
        if (this.search && !this.search.hidden) this.closeSearch();
        item.classList.add('is-open');
        item.querySelector('.zh__toggle').setAttribute('aria-expanded', 'true');
        item.querySelector('.zh__mega').hidden = false;
      }

      closeMega(item) {
        item.classList.remove('is-open');
        item.querySelector('.zh__toggle').setAttribute('aria-expanded', 'false');
        item.querySelector('.zh__mega').hidden = true;
      }

      openSearch() {
        this.items.forEach((item) => this.closeMega(item));
        this.search.hidden = false;
        this.searchBtn.setAttribute('aria-expanded', 'true');
        this.wrapper.classList.remove('zh-wrap--hidden');
        if (this.input) setTimeout(() => this.input.focus(), 30);
      }

      closeSearch(returnFocus) {
        this.search.hidden = true;
        this.searchBtn.setAttribute('aria-expanded', 'false');
        if (returnFocus) this.searchBtn.focus();
      }

      openDrawer() {
        this.drawer.hidden = false;
        this.burger.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('zh-lock');
        this.wrapper.classList.remove('zh-wrap--hidden');
        requestAnimationFrame(() => requestAnimationFrame(() => this.drawer.classList.add('is-open')));
        const close = this.drawer.querySelector('.zh__panel-head [data-zh-drawer-close]');
        setTimeout(() => close && close.focus(), 60);
        this.trap = (e) => {
          if (e.key !== 'Tab') return;
          const f = Array.from(this.drawer.querySelectorAll('a[href], button, input, summary')).filter((el) => el.offsetParent !== null);
          if (!f.length) return;
          const first = f[0];
          const last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        };
        this.drawer.addEventListener('keydown', this.trap);
      }

      closeDrawer() {
        if (!this.drawer || this.drawer.hidden) return;
        this.drawer.classList.remove('is-open');
        this.burger.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('zh-lock');
        this.drawer.removeEventListener('keydown', this.trap);
        setTimeout(() => { this.drawer.hidden = true; }, 280);
        this.burger.focus();
      }

      handleScroll() {
        const y = window.scrollY;
        const busy = this.querySelector('.zh__item.is-open') || (this.search && !this.search.hidden) || (this.drawer && !this.drawer.hidden);
        if (!busy && y > this.lastY && y > this.offsetHeight + 240) {
          this.wrapper.classList.add('zh-wrap--hidden');
        } else if (y < this.lastY) {
          this.wrapper.classList.remove('zh-wrap--hidden');
        }
        this.lastY = y;
      }

      esc(str) {
        return String(str || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
      }

      money(value) {
        const n = Number(value);
        if (!isFinite(n)) return '';
        const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
        if (!currency) return '';
        try {
          return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency }).format(n);
        } catch (e) {
          return '';
        }
      }

      async suggest(raw) {
        const q = raw.trim();
        if (this.quick) this.quick.hidden = q.length >= 2;
        if (q.length < 2) { this.results.innerHTML = ''; return; }
        if (this.controller) this.controller.abort();
        this.controller = new AbortController();
        const url = `${this.dataset.suggest}.json?q=${encodeURIComponent(q)}&resources[type]=product,collection,page&resources[limit]=6&resources[options][unavailable_products]=last`;
        try {
          const res = await fetch(url, { signal: this.controller.signal });
          if (!res.ok) throw new Error('search failed');
          const data = await res.json();
          const r = (data.resources && data.resources.results) || {};
          const products = r.products || [];
          const others = (r.collections || []).concat(r.pages || []);
          const all = `${this.dataset.searchUrl}?q=${encodeURIComponent(q)}&options[prefix]=last`;
          let html = '';
          if (products.length) {
            html += '<div class="zh__res-group"><p class="zap-eyebrow">Products</p><ul class="zh__res-products" role="list">';
            products.forEach((p) => {
              let img = (p.featured_image && p.featured_image.url) || p.image || '';
              if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=120';
              const price = this.money(p.price);
              html += `<li><a class="zh__res-product" href="${this.esc(p.url)}">${img ? `<img class="zh__res-img" src="${this.esc(img)}" alt="" width="56" height="56" loading="lazy">` : '<span class="zh__res-img"></span>'}<span class="zh__res-title">${this.esc(p.title)}${price ? `<span class="zh__res-price">${this.esc(price)}</span>` : ''}</span></a></li>`;
            });
            html += '</ul></div>';
          }
          if (others.length) {
            html += '<div class="zh__res-group"><p class="zap-eyebrow">Pages</p><ul class="zh__res-links" role="list">';
            others.forEach((o) => { html += `<li><a class="zh__chip" href="${this.esc(o.url)}">${this.esc(o.title)}</a></li>`; });
            html += '</ul></div>';
          }
          if (!products.length && !others.length) html = `<p class="zh__res-none">No results for “${this.esc(q)}”.</p>`;
          html += `<a class="zap-link-arrow zh__res-all" href="${this.esc(all)}">See all results for “${this.esc(q)}”</a>`;
          this.results.innerHTML = html;
        } catch (e) {
          if (e.name !== 'AbortError') this.results.innerHTML = '';
        }
      }
    });
  }

  /* Sign-up pop-up skin, part 2. A few touches the variables can't reach
     (capitals on the heading, a bolder button). Added to the Forms pop-up's
     own component once it appears. If Shopify renames its parts, these just
     stop applying and the pop-up keeps the variable styling above. */
  (() => {
    if (!document.querySelector('style[data-zap-forms-skin]') || typeof CSSStyleSheet === 'undefined') return;
    let sheet;
    try {
      sheet = new CSSStyleSheet();
      sheet.replaceSync(`
        [class*="_textHeading_"] { text-transform: uppercase !important; letter-spacing: 0 !important; line-height: 0.92 !important; }
        [class*="_textBody_"] p { margin-top: 10px !important; }
        button[data-testid="btn-form-submit"] { font-weight: 600 !important; font-size: 16px !important; letter-spacing: 0 !important; }
        [class*="_formDisclaimer_"] { opacity: 0.75 !important; }
        [class*="_teaserHeading_"] { text-transform: uppercase !important; letter-spacing: 0.02em !important; }
      `);
    } catch (e) { return; }
    const skin = (host) => {
      const root = host && host.shadowRoot;
      if (!root || root.adoptedStyleSheets.includes(sheet)) return;
      try { root.adoptedStyleSheets = [...root.adoptedStyleSheets, sheet]; } catch (e) { /* older browsers: variables still apply */ }
    };
    const scan = () => document.querySelectorAll('shopify-forms-embed').forEach(skin);
    scan();
    if (customElements && customElements.whenDefined) customElements.whenDefined('shopify-forms-embed').then(() => setTimeout(scan, 0));
    const watch = new MutationObserver((list) => {
      for (const m of list) for (const n of m.addedNodes) {
        if (n.nodeType === 1 && (n.tagName === 'SHOPIFY-FORMS-EMBED' || n.querySelector && n.querySelector('shopify-forms-embed'))) { setTimeout(scan, 0); return; }
      }
    });
    watch.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => watch.disconnect(), 120000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zap-ingredient-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zap-ingredient-finder')) {
    customElements.define('zap-ingredient-finder', class extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-zif-item]'));
        this.input = this.querySelector('[data-zif-search]');
        this.status = this.querySelector('[data-zif-status]');
        this.empty = this.querySelector('[data-zif-empty]');
        this.typeButtons = Array.from(this.querySelectorAll('[data-zif-type]'));
        this.type = 'all';
        this.pairs = (this.dataset.synonyms || '').split(/\n/).map((l) => l.split('=').map((x) => x.trim().toLowerCase())).filter((p) => p.length === 2 && p[0] && p[1]);
        this.items.forEach((item) => {
          let text = item.dataset.search || '';
          this.pairs.forEach(([a, b]) => { if (text.includes(b) && !text.includes(a)) text += ` ${a}`; else if (text.includes(a) && !text.includes(b)) text += ` ${b}`; });
          item.zifText = text;
          const inci = item.querySelector('[data-zif-inci]');
          if (inci) item.zifInci = inci.textContent;
        });
        this.typeButtons.forEach((btn) => btn.addEventListener('click', () => {
          this.type = btn.dataset.zifType;
          this.typeButtons.forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
          this.apply();
        }));
        if (this.input) {
          let t;
          this.input.addEventListener('input', () => { clearTimeout(t); t = setTimeout(() => this.apply(), 120); });
        }
        this.addEventListener('click', (e) => {
          const copy = e.target.closest('[data-zif-copy]');
          if (!copy) return;
          const item = copy.closest('[data-zif-item]');
          const text = item && item.zifInci ? item.zifInci.trim() : '';
          if (!text || !navigator.clipboard) return;
          navigator.clipboard.writeText(text).then(() => {
            const label = copy.textContent;
            copy.textContent = 'Copied';
            setTimeout(() => { copy.textContent = label; }, 1600);
          }).catch(() => {});
        });
        const hash = window.location.hash ? decodeURIComponent(window.location.hash.slice(1)) : '';
        const target = hash ? this.querySelector(`details[id="${CSS.escape(hash)}"]`) : null;
        if (target) target.open = true;
      }
      terms(q) {
        const list = [q];
        this.pairs.forEach(([a, b]) => { if (a === q || a.startsWith(q) && q.length > 3) list.push(b); if (b === q) list.push(a); });
        return [...new Set(list)];
      }
      esc(s) { return s.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }
      apply() {
        const q = this.input ? this.input.value.trim().toLowerCase() : '';
        const terms = q.length > 1 ? this.terms(q) : [];
        let shown = 0;
        this.items.forEach((item) => {
          const typeOk = this.type === 'all' || item.dataset.type === this.type;
          const qOk = !terms.length || terms.some((term) => item.zifText.includes(term));
          const show = typeOk && qOk;
          item.hidden = !show;
          if (show) shown += 1;
          const tag = item.querySelector('[data-zif-match]');
          const inci = item.querySelector('[data-zif-inci]');
          if (terms.length && show) {
            tag.textContent = `Contains: ${this.input.value.trim()}`;
            tag.hidden = false;
            if (inci && item.zifInci) {
              let html = this.esc(item.zifInci);
              terms.forEach((term) => {
                const re = new RegExp(`(${term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'ig');
                html = html.replace(re, '<mark>$1</mark>');
              });
              inci.innerHTML = html;
            }
          } else {
            tag.hidden = true;
            if (inci && item.zifInci && inci.innerHTML !== this.esc(item.zifInci)) inci.textContent = item.zifInci;
          }
        });
        const visible = this.items.filter((i) => !i.hidden);
        if (terms.length && visible.length && visible.length <= 3) visible.forEach((i) => { const d = i.querySelector('details'); if (d) d.open = true; });
        const raw = this.input ? this.input.value.trim() : '';
        if (terms.length) {
          this.status.textContent = shown ? `${shown} of ${this.items.length} products contain “${raw}”.` : `None of our products contain “${raw}”.`;
        } else {
          this.status.textContent = this.type === 'all' ? '' : `Showing ${shown} products.`;
        }
        if (this.empty) this.empty.hidden = shown > 0 || !terms.length;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zap-ingredient-glossary"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zap-ingredient-glossary')) {
    customElements.define('zap-ingredient-glossary', class extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-zig-item]'));
        this.groups = Array.from(this.querySelectorAll('[data-zig-group]'));
        this.input = this.querySelector('[data-zig-search]');
        this.status = this.querySelector('[data-zig-status]');
        this.empty = this.querySelector('[data-zig-empty]');
        if (!this.input) return;
        let t;
        this.input.addEventListener('input', () => { clearTimeout(t); t = setTimeout(() => this.apply(), 120); });
      }
      apply() {
        const q = this.input.value.trim().toLowerCase();
        let shown = 0;
        this.items.forEach((item) => {
          const ok = !q || (item.dataset.search || '').includes(q);
          item.hidden = !ok;
          if (ok) shown += 1;
        });
        this.groups.forEach((g) => { g.hidden = !g.querySelector('[data-zig-item]:not([hidden])'); });
        this.status.textContent = q ? (shown ? `${shown} ingredient${shown === 1 ? '' : 's'} found.` : '') : '';
        if (this.empty) this.empty.hidden = !q || shown > 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zap-kids-kit"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zap-kids-kit')) {
    const zapCartWord = (window.Shopify && Shopify.currency && Shopify.currency.active === 'GBP') ? 'basket' : 'cart';
    customElements.define('zap-kids-kit', class extends HTMLElement {
      connectedCallback() {
        this.max = parseInt(this.dataset.max, 10) || 4;
        this.root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        this.tiers = (this.dataset.tiers || '').split(',').map((t) => t.split(':').map(Number)).filter((t) => t.length === 2 && t[0] > 0 && t[1] > 0).map(([qty, pct]) => ({ qty, pct })).sort((a, b) => a.qty - b.qty);
        this.face = this.querySelector('[data-zkk-face]');
        this.zones = Array.from(this.querySelectorAll('.zkk__zone'));
        this.colours = Array.from(this.querySelectorAll('[data-zkk-colour]'));
        this.sizes = Array.from(this.querySelectorAll('[data-zkk-size]'));
        this.hint = this.querySelector('[data-zkk-hint]');
        this.banner = this.querySelector('[data-zkk-banner]');
        this.picked = [];

        this.colours.forEach((btn) => btn.addEventListener('click', () => this.toggle(btn)));
        this.sizes.forEach((r) => r.addEventListener('change', () => this.render()));
        this.querySelectorAll('[data-zkk-skin]').forEach((btn) => btn.addEventListener('click', () => {
          this.querySelectorAll('[data-zkk-skin]').forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
          this.face.style.setProperty('--zkk-skin', btn.dataset.zkkSkin);
        }));
        const name = this.querySelector('[data-zkk-name]');
        if (name) name.addEventListener('input', () => this.setName(name.value));
        const surprise = this.querySelector('[data-zkk-surprise]');
        if (surprise) surprise.addEventListener('click', () => this.surprise());
        this.querySelector('[data-zkk-add]').addEventListener('click', (e) => this.add(e.currentTarget, true));
        const only = this.querySelector('[data-zkk-cream-only]');
        if (only) only.addEventListener('click', (e) => this.add(e.currentTarget, false));

        const first = this.colours.find((b) => !b.disabled);
        if (first && this.hasAttribute('data-preselect')) this.toggle(first, true);
        this.render();
      }
      money(cents) {
        const value = (cents / 100).toFixed(2);
        const format = (this.dataset.moneyFormat || '').replace(/<[^>]*>/g, '').trim();
        if (!format) return `${(window.Shopify && Shopify.currency && Shopify.currency.active === 'GBP') ? '£' : '$'}${value}`;
        return format
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
          .replace(/\{\{\s*amount\s*\}\}/, value);
      }
      setName(raw) {
        const clean = raw.replace(/[^\p{L}\p{N} '\-]/gu, '').trim().slice(0, 14);
        if (!this.banner) return;
        this.banner.textContent = clean ? (this.dataset.bannerNamed || '[name]').replace('[name]', clean) : (this.dataset.banner || '');
      }
      toggle(btn, quiet) {
        const i = this.picked.indexOf(btn);
        if (i > -1) {
          this.picked.splice(i, 1);
          btn.setAttribute('aria-pressed', 'false');
        } else {
          if (this.picked.length >= this.max) {
            const oldest = this.picked.shift();
            oldest.setAttribute('aria-pressed', 'false');
          }
          this.picked.push(btn);
          btn.setAttribute('aria-pressed', 'true');
        }
        if (!quiet) this.wiggle();
        this.render();
      }
      surprise() {
        const open = this.colours.filter((b) => !b.disabled);
        if (!open.length) return;
        this.picked.forEach((b) => b.setAttribute('aria-pressed', 'false'));
        const count = Math.min(open.length, this.max, 2 + Math.floor(Math.random() * 2));
        const pool = open.slice();
        this.picked = [];
        for (let n = 0; n < count; n += 1) {
          const k = Math.floor(Math.random() * pool.length);
          const pick = pool.splice(k, 1)[0];
          pick.setAttribute('aria-pressed', 'true');
          this.picked.push(pick);
        }
        this.wiggle();
        this.render();
      }
      wiggle() {
        if (!this.face || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.face.classList.remove('is-wiggle');
        void this.face.offsetWidth;
        this.face.classList.add('is-wiggle');
      }
      tierFor(count) {
        let current = null;
        this.tiers.forEach((t) => { if (count >= t.qty) current = t; });
        return current;
      }
      render() {
        const zoneOf = [];
        this.picked.forEach((btn, i) => { zoneOf[i] = btn.dataset.hex; });
        // One stick paints the nose and cheeks; more sticks add the forehead and chin.
        const c = [zoneOf[0], zoneOf[1] || zoneOf[0], zoneOf[2], zoneOf[3]];
        this.zones.forEach((z, i) => {
          if (c[i]) {
            this.face.style.setProperty(`--zkk-c${i}`, c[i]);
            z.classList.add('is-on');
          } else {
            z.classList.remove('is-on');
          }
        });
        const zoneNames = ['nose', 'cheeks', 'forehead', 'chin'];
        this.colours.forEach((btn) => {
          const i = this.picked.indexOf(btn);
          const badge = btn.querySelector('[data-zkk-order]');
          if (badge) badge.textContent = i > -1 ? String(i + 1) : '';
          btn.setAttribute('aria-label', `${btn.dataset.name}${btn.disabled ? '' : (i > -1 ? `, picked for the ${zoneNames[i]}` : '')}`);
        });
        if (this.hint) this.hint.hidden = this.picked.length > 0;

        const size = this.sizes.find((r) => r.checked) || this.sizes.find((r) => !r.disabled);
        const creamPrice = size ? Number(size.dataset.price) : 0;
        const creamWas = size ? Number(size.dataset.compare) : 0;
        const sticks = this.picked.map((b) => ({ price: Number(b.dataset.price), eligible: b.dataset.eligible === 'true', name: b.dataset.name }));
        const stickTotal = sticks.reduce((a, s) => a + s.price, 0);
        const eligible = sticks.filter((s) => s.eligible);
        const tier = this.tierFor(eligible.length);
        // Shopify rounds a percentage discount per line, so do the same here.
        const saving = tier ? eligible.reduce((a, s) => a + Math.round(s.price * tier.pct / 100), 0) : 0;
        const total = creamPrice + stickTotal - saving;
        const was = creamWas + stickTotal;

        const lines = this.querySelector('[data-zkk-lines]');
        lines.innerHTML = '';
        const addLine = (label, value, cls) => {
          const li = document.createElement('li');
          if (cls) li.className = cls;
          const a = document.createElement('span'); a.textContent = label;
          const b = document.createElement('span'); b.textContent = value;
          li.append(a, b); lines.append(li);
        };
        if (size) addLine(size.closest('label').querySelector('.zkk__size-title').textContent.trim(), this.money(creamPrice));
        if (sticks.length) addLine(`${sticks.length} zinc stick${sticks.length > 1 ? 's' : ''} (${sticks.map((s) => s.name).join(', ')})`, this.money(stickTotal));
        if (saving > 0) addLine(`Mix and match: ${tier.pct}% off sticks`, `-${this.money(saving)}`, 'is-saving');

        this.querySelector('[data-zkk-total]').textContent = this.money(total);
        const wasEl = this.querySelector('[data-zkk-was]');
        wasEl.hidden = !(was > total);
        wasEl.textContent = was > total ? this.money(was) : '';

        const tierEl = this.querySelector('[data-zkk-tier]');
        if (tierEl) {
          const next = this.tiers.find((t) => t.qty > eligible.length);
          if (!this.tiers.length || !eligible.length) tierEl.textContent = '';
          else if (next && eligible.length < this.max) tierEl.textContent = `Pick ${next.qty - eligible.length} more stick${next.qty - eligible.length > 1 ? 's' : ''} to save ${next.pct}% on sticks.${tier ? ` You're saving ${tier.pct}% now.` : ''}`;
          else if (tier) tierEl.textContent = `Nice. ${eligible.length} sticks: ${tier.pct}% off sticks, taken off in your ${zapCartWord}.`;
          else tierEl.textContent = '';
        }
        const add = this.querySelector('[data-zkk-add]');
        add.textContent = (this.dataset.button || 'Add their kit').replace('[total]', this.money(total));
        add.disabled = !size;
      }
      async add(btn, withSticks) {
        if (this.busy) return;
        const size = this.sizes.find((r) => r.checked);
        const msg = this.querySelector('[data-zkk-msg]');
        msg.textContent = '';
        msg.classList.remove('is-error');
        if (!size) { msg.classList.add('is-error'); msg.textContent = 'Please pick a size.'; return; }
        const items = [{ id: Number(size.value), quantity: 1 }];
        if (withSticks) this.picked.forEach((b) => items.push({ id: Number(b.dataset.id), quantity: 1 }));
        this.busy = true;
        btn.setAttribute('aria-busy', 'true');
        try {
          const res = await fetch(`${this.root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items, sections: 'cart-icon-bubble', sections_url: window.location.pathname })
          });
          const data = await res.json().catch(() => null);
          if (!res.ok || !data || data.status) throw Object.assign(new Error('add failed'), { userMessage: data && data.description });
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'zap-kids-kit', productVariantId: items[0].id, cartData: data });
          }
          document.dispatchEvent(new CustomEvent('zap:cart-changed'));
          if (this.dataset.after === 'cart') { window.location.href = this.dataset.cart || '/cart'; return; }
          const bubble = document.getElementById('cart-icon-bubble');
          const html = data.sections && data.sections['cart-icon-bubble'];
          if (bubble && html) {
            const inner = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
            if (inner) bubble.innerHTML = inner.innerHTML;
          }
          msg.textContent = `Added to your ${zapCartWord}.`;
        } catch (err) {
          msg.classList.add('is-error');
          msg.textContent = (err && err.userMessage) || 'Sorry, that could not be added. Please try again.';
        } finally {
          this.busy = false;
          btn.removeAttribute('aria-busy');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zap-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const smooth = () => !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const canSubscribe = () => typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined';

    const formatMoney = (cents, format) => {
      const value = (cents / 100).toFixed(2);
      const fmt = (format || '').replace(/<[^>]*>/g, '').trim();
      if (!fmt) return `£${value}`;
      return fmt
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
        .replace(/\{\{\s*amount\s*\}\}/, value);
    };

    // Adds one item and opens the theme's cart pop-up or drawer when there is one.
    const addToCart = async (variantId, quantity) => {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const canNotify = cart && typeof cart.renderContents === 'function' && typeof cart.getSectionsToRender === 'function';
      let data;
      if (canNotify) {
        const body = new FormData();
        body.append('id', variantId);
        body.append('quantity', quantity);
        body.append('sections', cart.getSectionsToRender().map((section) => section.id));
        body.append('sections_url', window.location.pathname);
        const res = await fetch(`${root}cart/add`, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body });
        data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'Sorry, that could not be added.');
        try { cart.renderContents(data); cart.classList.remove('is-empty'); } catch (e) { /* the pop-up is optional */ }
      } else {
        const res = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variantId, quantity }] }) });
        data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'Sorry, that could not be added.');
      }
      if (canSubscribe() && typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'zap-product', productVariantId: variantId, cartData: data });
      document.dispatchEvent(new CustomEvent('zap:cart-changed'));
      return data;
    };

    if (!customElements.get('zap-gallery')) {
      customElements.define('zap-gallery', class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.zpg__track');
          if (!this.track) return;
          this.slides = Array.from(this.track.children);
          this.thumbs = Array.from(this.querySelectorAll('.zpg__thumb'));
          this.arrows = Array.from(this.querySelectorAll('[data-step]'));
          this.counter = this.querySelector('[data-counter]');
          this.index = 0;
          this.target = null;
          this.thumbs.forEach((thumb) => thumb.addEventListener('click', () => this.go(parseInt(thumb.dataset.index, 10))));
          this.arrows.forEach((arrow) => arrow.addEventListener('click', () => this.go(this.index + parseInt(arrow.dataset.step, 10))));
          this.track.addEventListener('scroll', () => {
            cancelAnimationFrame(this.raf);
            this.raf = requestAnimationFrame(() => this.sync());
          }, { passive: true });
          this.track.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowRight') { event.preventDefault(); this.go(this.index + 1); }
            if (event.key === 'ArrowLeft') { event.preventDefault(); this.go(this.index - 1); }
          });
          this.dialog = this.querySelector('.zpg__dialog');
          if (this.dialog) {
            this.dialogImg = this.dialog.querySelector('.zpg__dialog-img');
            this.querySelectorAll('.zpg__zoom').forEach((btn) => btn.addEventListener('click', () => this.zoom(btn)));
            this.dialog.addEventListener('click', (event) => {
              if (event.target === this.dialog || event.target.closest('[data-close]')) this.dialog.close();
            });
          }
          // Keep the current image in place when the gallery changes size (rotating a phone, resizing).
          if ('ResizeObserver' in window) {
            this.resizer = new ResizeObserver(() => {
              this.resizing = true;
              clearTimeout(this.resizeTimer);
              this.resizeTimer = setTimeout(() => { this.resizing = false; }, 250);
              const slide = this.slides[this.index];
              if (slide) this.track.scrollTo({ left: slide.offsetLeft, behavior: 'auto' });
            });
            this.resizer.observe(this.track);
          }
          const start = parseInt(this.dataset.start, 10) || 0;
          if (start > 0) requestAnimationFrame(() => this.go(start, false));
          else this.setActive(0);
          if (canSubscribe()) {
            this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
              const data = event && event.data;
              if (!data || data.sectionId !== this.dataset.section || !data.variant || !data.variant.featured_media) return;
              const i = this.slides.findIndex((slide) => slide.dataset.mediaId === String(data.variant.featured_media.id));
              if (i > -1) this.go(i);
            });
          }
        }
        disconnectedCallback() {
          if (this.unsubscribe) this.unsubscribe();
          if (this.resizer) this.resizer.disconnect();
        }
        go(i, animate = true) {
          if (!this.slides.length) return;
          const n = Math.max(0, Math.min(this.slides.length - 1, i));
          this.target = n;
          clearTimeout(this.release);
          this.release = setTimeout(() => { this.target = null; }, 700);
          this.track.scrollTo({ left: this.slides[n].offsetLeft, behavior: animate && smooth() ? 'smooth' : 'auto' });
          this.setActive(n);
        }
        sync() {
          const width = this.track.clientWidth;
          if (!width) return;
          if (this.resizing) return;
          const n = Math.round(this.track.scrollLeft / width);
          if (this.target !== null) {
            if (n === this.target) this.target = null;
            return;
          }
          if (n !== this.index) this.setActive(n);
        }
        setActive(n) {
          this.index = n;
          this.thumbs.forEach((thumb, i) => {
            if (i === n) thumb.setAttribute('aria-current', 'true');
            else thumb.removeAttribute('aria-current');
          });
          const thumb = this.thumbs[n];
          const row = thumb && thumb.parentElement;
          if (row && row.scrollWidth > row.clientWidth) {
            row.scrollTo({ left: thumb.offsetLeft - (row.clientWidth - thumb.offsetWidth) / 2, behavior: smooth() ? 'smooth' : 'auto' });
          }
          if (this.counter) this.counter.textContent = n + 1;
          this.arrows.forEach((arrow) => {
            const step = parseInt(arrow.dataset.step, 10);
            arrow.disabled = (step < 0 && n === 0) || (step > 0 && n === this.slides.length - 1);
          });
          this.slides.forEach((slide, i) => {
            if (i !== n) slide.querySelectorAll('video').forEach((video) => video.pause());
          });
        }
        zoom(btn) {
          if (!this.dialog || !this.dialogImg || typeof this.dialog.showModal !== 'function') return;
          this.dialogImg.src = btn.dataset.zoom;
          this.dialogImg.alt = btn.dataset.alt || '';
          this.dialogImg.hidden = false;
          this.dialog.showModal();
        }
      });
    }

    if (!customElements.get('zap-qty')) {
      customElements.define('zap-qty', class extends HTMLElement {
        connectedCallback() {
          this.input = this.querySelector('input');
          if (!this.input) return;
          this.minus = this.querySelector('button[name="minus"]');
          this.querySelectorAll('button[name]').forEach((btn) => btn.addEventListener('click', () => {
            const current = parseInt(this.input.value, 10) || 1;
            const next = Math.max(1, current + (btn.name === 'plus' ? 1 : -1));
            if (next === current) return;
            this.input.value = next;
            this.input.dispatchEvent(new Event('change', { bubbles: true }));
          }));
          this.input.addEventListener('change', () => this.update());
          this.input.addEventListener('input', () => this.update());
          this.update();
        }
        update() {
          const value = parseInt(this.input.value, 10);
          if (this.input.value !== '' && (!value || value < 1)) this.input.value = 1;
          if (this.minus) this.minus.setAttribute('aria-disabled', (parseInt(this.input.value, 10) || 1) <= 1 ? 'true' : 'false');
        }
      });
    }

    if (!customElements.get('zap-buy')) {
      customElements.define('zap-buy', class extends HTMLElement {
        connectedCallback() {
          this.section = this.dataset.section;
          this.formId = `product-form-${this.section}`;
          this.price = parseInt(this.dataset.price, 10) || 0;
          this.available = this.dataset.available === 'true';
          this.button = document.getElementById(`ProductSubmitButton-${this.section}`);
          this.label = this.button ? this.button.dataset.label : '';
          this.totalEl = this.querySelector('[data-atc-total]');
          this.savingEl = this.querySelector('[data-saving]');
          this.multibuy = this.querySelector('zap-multibuy');
          this.onChange = (event) => {
            const t = event.target;
            if (t && t.name === 'quantity' && (t.getAttribute('form') === this.formId || (t.form && t.form.id === this.formId))) this.render();
          };
          document.addEventListener('change', this.onChange);
          this.querySelectorAll('[data-add-variant]').forEach((btn) => btn.addEventListener('click', () => this.addOne(btn)));
          // Upgrade nudge: show the one for the selected size, and let its button pick the bigger size.
          this.syncUpgrade = (id) => {
            this.querySelectorAll('[data-zp-upgrade-for]').forEach((el) => { el.hidden = String(el.dataset.zpUpgradeFor) !== String(id); });
          };
          this.querySelectorAll('[data-zp-upgrade-to]').forEach((btn) => btn.addEventListener('click', () => {
            const tile = [...this.querySelectorAll('[data-zp-tiles] .zp__tile-input')].find((t) => String(t.dataset.variantId) === String(btn.dataset.zpUpgradeTo));
            if (!tile) return;
            tile.checked = true;
            tile.dispatchEvent(new Event('change', { bubbles: true }));
            tile.focus({ preventScroll: true });
          }));
          // Size tiles: our own radios drive Dawn's (hidden) variant picker, so
          // product-info.js still does the variant switching, price and URL.
          this.querySelectorAll('[data-zp-tiles] .zp__tile-input').forEach((tile) => {
            tile.addEventListener('change', () => {
              if (!tile.checked) return;
              this.syncUpgrade(tile.dataset.variantId);
              const picker = this.querySelector('.zp__dawn-picker');
              if (!picker) return;
              const target = [...picker.querySelectorAll('input[type="radio"]')].find((i) => i.value === tile.value);
              if (target) {
                target.checked = true;
                target.dispatchEvent(new Event('change', { bubbles: true }));
                return;
              }
              const select = picker.querySelector('select');
              if (select) {
                select.value = tile.value;
                select.dispatchEvent(new Event('change', { bubbles: true }));
              }
            });
          });
          if (canSubscribe()) {
            this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
              const data = event && event.data;
              if (!data || data.sectionId !== this.section) return;
              const variant = data.variant;
              this.available = !!(variant && variant.available);
              if (variant) {
                this.price = variant.price;
                this.querySelectorAll('[data-zp-selected]').forEach((el) => { el.textContent = variant.title; });
                this.querySelectorAll('[data-zp-tiles] .zp__tile-input').forEach((tile) => { tile.checked = String(tile.dataset.variantId) === String(variant.id); });
                this.syncUpgrade(variant.id);
                const stickyTitle = document.querySelector(`#ZpSticky-${this.section} [data-sticky-title]`);
                if (stickyTitle) stickyTitle.textContent = `${stickyTitle.dataset.base} · ${variant.title}`;
              }
              this.render();
            });
          }
          // Make sure the basket gets the variant shown in the picker, even if another
          // script has changed the form's hidden variant input in the meantime.
          const form = document.getElementById(this.formId);
          if (form) {
            form.addEventListener('submit', () => {
              const json = this.querySelector('variant-selects [data-selected-variant]');
              const input = form.querySelector('input[name="id"]');
              if (!json || !input) return;
              try {
                const variant = JSON.parse(json.textContent);
                if (variant && variant.id && String(input.value) !== String(variant.id)) input.value = variant.id;
              } catch (e) { /* keep the form's own value */ }
            }, true);
          }
          this.setupSticky();
          this.render();
        }
        disconnectedCallback() {
          document.removeEventListener('change', this.onChange);
          if (this.unsubscribe) this.unsubscribe();
          if (this.onScroll) {
            window.removeEventListener('scroll', this.onScroll);
            window.removeEventListener('resize', this.onScroll);
          }
        }
        money(cents) { return formatMoney(cents, this.dataset.moneyFormat); }
        tiers() {
          if (!this.multibuy) return [];
          return (this.multibuy.dataset.tiers || '').split(',').filter(Boolean)
            .map((t) => t.split(':').map(Number)).filter(([q, p]) => q > 0 && p > 0)
            .map(([qty, pct]) => ({ qty, pct })).sort((a, b) => a.qty - b.qty);
        }
        words(n) {
          const mb = this.multibuy;
          if (!mb) return n === 1 ? 'item' : 'items';
          return n === 1 ? (mb.dataset.wordOne || 'stick') : (mb.dataset.word || 'sticks');
        }
        qty() {
          const form = document.getElementById(this.formId);
          const input = document.querySelector(`input[name="quantity"][form="${this.formId}"]`) || (form && form.querySelector('input[name="quantity"]'));
          return Math.max(1, parseInt(input && input.value, 10) || 1);
        }
        render() {
          const q = this.qty();
          let pct = 0;
          this.tiers().forEach((t) => { if (q >= t.qty) pct = t.pct; });
          const subtotal = this.price * q;
          const saving = Math.round(subtotal * pct / 100);
          const total = subtotal - saving;
          const enabled = this.available && this.button && !this.button.hasAttribute('disabled');
          if (this.button && enabled && this.label) {
            const span = this.button.querySelector('span');
            if (span) span.textContent = this.label;
          }
          if (this.totalEl) this.totalEl.textContent = this.available ? ` · ${this.money(total)}` : '';
          if (this.savingEl) {
            if (saving > 0 && this.available) {
              this.savingEl.textContent = `You save ${this.money(saving)} with ${pct}% off ${q} ${this.words(q)}.`;
              this.savingEl.hidden = false;
            } else {
              this.savingEl.hidden = true;
            }
          }
          this.renderSticky(q, total, pct);
        }
        setupSticky() {
          this.sticky = document.getElementById(`ZpSticky-${this.section}`);
          if (!this.sticky || !this.button) return;
          this.stickyBtn = this.sticky.querySelector('[data-sticky-add]');
          this.stickyLabel = this.sticky.querySelector('[data-sticky-label]');
          this.stickyTotal = this.sticky.querySelector('[data-sticky-total]');
          this.stickyMeta = this.sticky.querySelector('[data-sticky-meta]');
          this.stickyText = this.stickyLabel ? this.stickyLabel.textContent : '';
          if (this.stickyBtn) {
            this.stickyBtn.addEventListener('click', () => {
              if (this.button.hasAttribute('disabled')) {
                this.button.scrollIntoView({ behavior: smooth() ? 'smooth' : 'auto', block: 'center' });
                return;
              }
              this.button.click();
            });
          }
          // Show the bar once the main button has scrolled up out of view (checked on scroll,
          // so jumping straight down the page, e.g. from the reviews link, still shows it).
          this.onScroll = () => {
            if (this.scrollFrame) return;
            this.scrollFrame = requestAnimationFrame(() => {
              this.scrollFrame = null;
              const rect = this.button.getBoundingClientRect();
              const past = rect.bottom < 0;
              this.sticky.classList.toggle('is-visible', past);
            });
          };
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onScroll, { passive: true });
          this.onScroll();
        }
        renderSticky(q, total, pct) {
          if (!this.stickyBtn) return;
          this.stickyBtn.disabled = !this.available;
          if (this.stickyLabel) this.stickyLabel.textContent = this.available ? this.stickyText : 'Sold out';
          if (this.stickyTotal) this.stickyTotal.textContent = this.available ? ` · ${this.money(total)}` : '';
          if (this.stickyMeta) {
            this.stickyMeta.textContent = q > 1 ? `${q} ${this.words(q)}${pct ? `, ${pct}% off` : ''}` : (this.stickyMeta.dataset.default || '');
          }
        }
        async addOne(btn) {
          const id = Number(btn.dataset.addVariant);
          if (!id || btn.getAttribute('aria-busy') === 'true') return;
          const label = btn.querySelector('[data-label]') || btn;
          const original = label.textContent;
          btn.setAttribute('aria-busy', 'true');
          try {
            await addToCart(id, 1);
            label.textContent = 'Added';
            btn.classList.add('is-added');
          } catch (e) {
            label.textContent = 'Try again';
          } finally {
            btn.removeAttribute('aria-busy');
            setTimeout(() => { label.textContent = original; btn.classList.remove('is-added'); }, 2000);
          }
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zap-quiz"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zap-quiz')) {
    customElements.define('zap-quiz', class extends HTMLElement {
      connectedCallback() {
        this.answers = Array.from(this.querySelectorAll('.zap-quiz__answer'));
        this.answers.forEach((btn) => btn.addEventListener('click', () => this.show(btn)));
        this.querySelectorAll('.zap-quiz__add').forEach((btn) => btn.addEventListener('click', () => this.add(btn)));
      }
      show(btn) {
        this.answers.forEach((b) => b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'));
        this.querySelectorAll('.zap-quiz__result').forEach((panel) => { panel.hidden = panel.id !== btn.dataset.target; });
      }
      async add(btn) {
        const ids = (btn.dataset.ids || '').split(',').filter(Boolean);
        if (!ids.length) return;
        const error = btn.parentElement.querySelector('.zap-quiz__error');
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        try {
          const res = await fetch(`${this.dataset.addUrl}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: ids.map((id) => ({ id: Number(id), quantity: 1 })) })
          });
          if (!res.ok) throw new Error('add failed');
          window.location.href = this.dataset.cartUrl;
        } catch (e) {
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          if (error) error.hidden = false;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zap-steps"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zap-steps')) {
    customElements.define('zap-steps', class extends HTMLElement {
      connectedCallback() {
        this.root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        this.msg = this.querySelector('[data-zst-msg]');
        this.live = this.querySelector('[data-zst-live]');
        this.addEventListener('click', (e) => {
          const one = e.target.closest('[data-zst-add]');
          if (one) { e.preventDefault(); this.add([Number(one.dataset.zstAdd)], one, false); return; }
          const kit = e.target.closest('[data-zst-kit]');
          if (kit) {
            e.preventDefault();
            const ids = kit.dataset.zstKit.split(',').map(Number).filter(Boolean);
            this.add(ids, kit, this.dataset.after === 'cart');
          }
        });
      }
      async add(ids, btn, goToCart) {
        if (!ids.length || this.busy) return;
        this.busy = true;
        btn.setAttribute('aria-busy', 'true');
        if (this.msg) this.msg.textContent = '';
        const onCart = /\/cart\/?$/.test(window.location.pathname);
        const notify = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const canNotify = !goToCart && !onCart && ids.length === 1 && notify && typeof notify.renderContents === 'function' && typeof notify.getSectionsToRender === 'function';
        try {
          let data;
          if (canNotify) {
            const body = new FormData();
            body.append('id', ids[0]);
            body.append('quantity', 1);
            body.append('sections', notify.getSectionsToRender().map((s) => s.id));
            body.append('sections_url', window.location.pathname);
            const res = await fetch(`${this.root}cart/add`, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body });
            data = await res.json().catch(() => null);
            if (!res.ok || !data || data.status) throw Object.assign(new Error('add failed'), { userMessage: data && data.description });
            if (typeof notify.setActiveElement === 'function') notify.setActiveElement(btn);
            try { notify.renderContents(data); notify.classList.remove('is-empty'); } catch (err) { /* the pop-up is optional */ }
          } else {
            const res = await fetch(`${this.root}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: ids.map((id) => ({ id, quantity: 1 })), sections: 'cart-icon-bubble', sections_url: window.location.pathname })
            });
            data = await res.json().catch(() => null);
            if (!res.ok || !data || data.status) throw Object.assign(new Error('add failed'), { userMessage: data && data.description });
            if (goToCart) { window.location.href = this.dataset.cart || '/cart'; return; }
            const bubble = document.getElementById('cart-icon-bubble');
            const html = data.sections && data.sections['cart-icon-bubble'];
            if (bubble && html) {
              const inner = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
              if (inner) bubble.innerHTML = inner.innerHTML;
            }
            if (this.msg && ids.length > 1) this.msg.textContent = 'Added to your basket.';
          }
          if (this.live && ids.length === 1) this.live.textContent = 'Added to your basket.';
          btn.classList.add('is-added');
          setTimeout(() => btn.classList.remove('is-added'), 1800);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'zap-steps', productVariantId: ids[0], cartData: data });
          }
          document.dispatchEvent(new CustomEvent('zap:cart-changed'));
          if (onCart && !document.querySelector('cart-items, zap-cart')) window.location.reload();
        } catch (err) {
          const text = (err && err.userMessage) || 'Sorry, that could not be added. Please try again.';
          if (this.msg && ids.length > 1) this.msg.textContent = text;
          else if (this.live) this.live.textContent = text;
        } finally {
          this.busy = false;
          btn.removeAttribute('aria-busy');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zap-timeline"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zap-timeline')) {
    customElements.define('zap-timeline', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.ztl__track');
        this.items = Array.from(this.querySelectorAll('[data-ztl-item]'));
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce || !('IntersectionObserver' in window) || !this.track) return;
        this.classList.add('ztl--js');
        this.io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-in');
              this.io.unobserve(entry.target);
            }
          });
        }, { rootMargin: '0px 0px -15% 0px', threshold: 0.15 });
        this.items.forEach((item) => this.io.observe(item));
        this.onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => {
            this.ticking = false;
            const rect = this.track.getBoundingClientRect();
            const mid = window.innerHeight * 0.6;
            const p = Math.min(1, Math.max(0, (mid - rect.top) / Math.max(rect.height, 1)));
            this.style.setProperty('--ztl-progress', p.toFixed(3));
          });
        };
        this.onScroll();
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);
      }
      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.onScroll) {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onScroll);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zap-trade-form"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zap-trade-form')) {
    customElements.define('zap-trade-form', class extends HTMLElement {
      connectedCallback() {
        const notice = this.querySelector('[data-ztr-notice]');
        if (notice) { notice.scrollIntoView({ block: 'center' }); notice.focus({ preventScroll: true }); }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zap-zinc-stick"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zap-swatches')) {
    customElements.define('zap-swatches', class extends HTMLElement {
      connectedCallback() {
        this.swatches = Array.from(this.querySelectorAll('.zap-stick__swatch'));
        this.nameEl = this.querySelector('[data-zap-name]');
        this.wordEl = this.querySelector('[data-zap-word]');
        this.imgEl = this.querySelector('[data-zap-img]');
        this.artEl = this.querySelector('[data-zap-art]');
        this.ctaEl = this.querySelector('[data-zap-cta]');
        this.defaultLink = this.ctaEl ? this.ctaEl.dataset.defaultLink || this.ctaEl.getAttribute('href') : '';
        this.defaultImg = this.imgEl ? this.imgEl.dataset.defaultImg || '' : '';
        this.swatches.forEach((btn) => btn.addEventListener('click', () => this.select(btn)));
        if (this.swatches[0]) this.select(this.swatches[0], true);
      }
      readable(hex) {
        const h = (hex || '').replace('#', '');
        if (h.length !== 6) return true;
        const c = [0, 2, 4].map((i) => parseInt(h.slice(i, i + 2), 16) / 255).map((v) => (v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4)));
        const lum = 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
        return (lum + 0.05) / (0.0144 + 0.05) >= 4.5;
      }
      select(btn, initial) {
        this.swatches.forEach((b) => b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'));
        const colour = btn.dataset.colour;
        this.style.setProperty('--zap-stick', colour);
        this.style.setProperty('--zap-word', this.readable(colour) ? colour : '#FFC72C');
        if (this.nameEl) this.nameEl.textContent = btn.dataset.name;
        if (this.ctaEl) this.ctaEl.setAttribute('href', btn.dataset.link || this.defaultLink);
        const img = btn.dataset.image || this.defaultImg;
        if (this.imgEl && this.artEl) {
          if (img) {
            this.imgEl.src = img;
            this.imgEl.hidden = false;
            this.artEl.hidden = true;
          } else {
            this.imgEl.hidden = true;
            this.artEl.hidden = false;
          }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
